import { userAuthHeader } from 'src/main_app/utils/user_utils/user-auth-header'
import apiDeleteRequest from './api-delete-request'

const deleteWithToken = apiPath => config => apiDeleteRequest(apiPath)({
    headers: userAuthHeader,
    ...config,
})

export default deleteWithToken